import BaseModel from "./BaseModel";
import FileHandler from "@/composables/handlers/FileHandler";

/**
 * SellingMaterial
 */
export default class SellingMaterial extends BaseModel {
  constructor({
    id,
    name,
    description,
    source,
    mime_type,
    created_at,
    updated_at,
    hasFile,
    sellingMaterialGroupId,
    sellingMaterialGroupName
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.description = description || null;

    /*
     * O source normalmente não vem nas listagens.
     * Ele permanece aqui para compatibilidade com outros
     * fluxos que eventualmente o utilizem.
     */
    this.source = source || null;

    this.mime_type = mime_type || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;

    this.hasFile = hasFile == 'has';

    this.sellingMaterialGroupId =
      sellingMaterialGroupId || null;

    this.sellingMaterialGroupName =
      sellingMaterialGroupName || null;
  }

  /**
   * Gets SellingMaterial extension
   *
   * @returns {String}
   */
  getExtension() {
    const extensions = FileHandler.getMimeTypes();

    return extensions[this.mime_type] != undefined
      ? extensions[this.mime_type]
      : '.txt';
  }

  /**
   * Gets a human-readable file type.
   *
   * @returns {String}
   */
  getFileType() {
    if (!this.mime_type) {
      return 'Arquivo';
    }

    if (this.mime_type === 'application/pdf') {
      return 'PDF';
    }

    if (
      this.mime_type.includes(
        'word'
      ) ||
      this.mime_type.includes(
        'document'
      )
    ) {
      return 'DOCX';
    }

    if (this.mime_type.includes('excel')) {
      return 'XLSX';
    }

    if (this.mime_type.startsWith('image/')) {
      return 'Imagem';
    }

    if (this.mime_type.startsWith('audio/')) {
      return 'Áudio';
    }

    if (this.mime_type.startsWith('video/')) {
      return 'Vídeo';
    }

    return 'Arquivo';
  }

  /**
   * Returns an icon according to the MIME type.
   *
   * @returns {String}
   */
  getFileIcon() {
    if (!this.mime_type) {
      return 'pi pi-file';
    }

    if (this.mime_type === 'application/pdf') {
      return 'pi pi-file-pdf';
    }

    if (
      this.mime_type.includes('word') ||
      this.mime_type.includes('document')
    ) {
      return 'pi pi-file-word';
    }

    if (this.mime_type.includes('excel')) {
      return 'pi pi-file-excel';
    }

    if (this.mime_type.startsWith('image/')) {
      return 'pi pi-image';
    }

    if (this.mime_type.startsWith('audio/')) {
      return 'pi pi-volume-up';
    }

    if (this.mime_type.startsWith('video/')) {
      return 'pi pi-video';
    }

    return 'pi pi-file';
  }

  /**
   * Determines whether the file can be previewed
   * directly in the browser.
   *
   * @returns {Boolean}
   */
  canPreview() {
    if (!this.hasFile) {
      return false;
    }

    return (
      this.mime_type === 'application/pdf' ||
      this.mime_type?.startsWith('image/')
    );
  }
}